export const ToastMessagesTypes = {
  SET_TOAST_MESSAGES: "SET_TOAST_MESSAGES",
  POP_TOAST_MESSAGES: "POP_TOAST_MESSAGES",
};
